import { Navigate, Outlet, useLocation } from "react-router";
import { RealtimeProvider } from "../shared/realtime/RealtimeProvider.tsx";
import { useReturnTo, withReturnTo } from "../shared/session/returnTo.ts";
import { useSession } from "../shared/session/SessionProvider.tsx";

const HOME = "/feed";

/**
 * Защищённые маршруты: без сессии — вход с возвратом сюда; закончившаяся сессия — Start.
 * С сессией держит App WS — одно соединение на все защищённые экраны.
 */
export function RequireSession() {
  const { status } = useSession();
  const location = useLocation();
  if (status === "authenticated") {
    return (
      <RealtimeProvider>
        <Outlet />
      </RealtimeProvider>
    );
  }
  if (status === "ended") return <Navigate to="/" replace />;
  return <Navigate to={withReturnTo("/login", `${location.pathname}${location.search}${location.hash}`)} replace />;
}

/** Start, вход и регистрация: с сессией ведут на исходный URL или на главную. */
export function GuestOnly() {
  const { status } = useSession();
  const returnTo = useReturnTo();
  if (status !== "authenticated") return <Outlet />;
  return <Navigate to={returnTo ?? HOME} replace />;
}
